function logMessage(message) {
    console.log(message);
    const logDisplay = document.getElementById("log-display");
    const loggingEnabled = document.getElementById("enable-logging")?.checked;
    
    if (logDisplay && loggingEnabled) {
        const timestamp = new Date().toLocaleTimeString();
        logDisplay.style.display = "block";
        const newMessage = document.createElement('div');
        newMessage.textContent = `${timestamp}: ${message}`;
        logDisplay.appendChild(newMessage);
        logDisplay.scrollTop = logDisplay.scrollHeight;
    } else if (logDisplay) {
        logDisplay.style.display = "none";
    }
}

let baseApiUrl = null;

async function getBaseApiUrl() {
    if (baseApiUrl) return baseApiUrl;

    try {
        logMessage(`Config: Getting base API URL`);
        // First check URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        let serverParam = urlParams.get('server');
        if (serverParam && !serverParam.startsWith('http')) {
            serverParam = `https://${serverParam}`;
            logMessage(`Config: Server parameter from URL: ${serverParam}`);
            return serverParam;
        }
        try {
            const response = await fetch('/config.json');
            if (response.ok) {
                const config = await response.json();
                if (config.apiServerUrl && config.apiServerUrl !== 'APISERVERURL') {
                    baseApiUrl = config.apiServerUrl;
                    logMessage(`Using API URL from config.json: ${baseApiUrl}`);
                    return baseApiUrl;
                }
            }
        } catch (e) {
            logMessage('Could not load from config.json', e);
        }

        // Next check meta tag
        const serverUrlMeta = document.querySelector('meta[name="server-url"]');
        if (serverUrlMeta) {
            let metaUrl = serverUrlMeta.getAttribute('content');
            if (metaUrl && metaUrl != 'APISERVERURL') {
                // Add https:// if not starting with http
                if (!metaUrl.startsWith('http')) {
                    metaUrl = `https://${metaUrl}`;
                }
                logMessage(`Config: Using URL from meta tag: ${metaUrl}`);
                return metaUrl;
            }
        }

        // Use URL parameter or default
        baseApiUrl = (serverParam || 'https://localhost:9905');

        logMessage(`Config: Using API URL: ${baseApiUrl}`);
        return baseApiUrl;
    } catch (error) {
        logMessage(`Config: Error getting API URL: ${error}`);
        return 'https://localhost:9905';
    }
}

export const ConfigManager = {
    getApiUrl: async (endpoint) => {
        const baseUrl = await getBaseApiUrl();
        return `${baseUrl}${endpoint}`;
    }
};